import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UtilitaService } from '../../services/utilita.service';

@Component({
  selector: 'app-dipartimenti-dettaglio',
  templateUrl: './dipartimenti-dettaglio.component.html',
  styleUrls: ['./dipartimenti-dettaglio.component.css']
})
export class DipartimentiDettaglioComponent implements OnInit {
  titolo: string = '';
  frmInserimento!: FormGroup;
  objdettaglio: any;
  lstdipartimenti: any;
  lstAtenei: any;

  constructor(public dialogRef: MatDialogRef<DipartimentiDettaglioComponent>,
    private srvUtilita: UtilitaService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private fb: FormBuilder,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.titolo = 'Dettaglio Dipartimento'
  }

  ngOnInit(): void {
    this.frmInserimento = this.fb.group({
      idDipartimento: [null],
      Dipartimento: [null],
      idAteneo: [null],
      Visibile: [1]
    })

    if (this.data.iValore >= 0) {
      // console.log('ivalore modale', this.data.iValore)
      this.getDettaglio(this.data.iValore)
    }
    else {
      this.titolo = this.titolo + " - Inserimento";
    }

    this.getAteneo();

  }

  getAteneo() {
    this.srvUtilita.getLista('Utenti/GetAteneiLista').subscribe((res: any) => {
      this.lstAtenei = res;
      // console.log('atenei', res)
    }, (err: any) => {
    })
  }

  getDettaglio(iValore: number) {
  //  console.log('iValore', iValore)
    this.srvUtilita.getObj('Utenti/GetDipartimentiDettaglio?idDipartimento=' + iValore).subscribe((res: any) => {
      this.objdettaglio = res
      this.frmInserimento.patchValue(this.objdettaglio)
 //     console.log('dettaglio', res)

      //this.titolo = this.titolo + ": " + this.objdettaglio.Dipartimento
    })
  }

  btnSalva() {
    let objInserimento: any
    objInserimento = this.frmInserimento.value

    if (objInserimento.Visibile == true) {
      objInserimento.Visibile = 1
    } else { objInserimento.Visibile = 0 }

    const obj = {
      idDipartimento: this.data.iValore,
      Dipartimento: objInserimento.Dipartimento,
      idAteneo: objInserimento.idAteneo,
      Visibile: objInserimento.Visibile
    }


    this.srvUtilita.postObj('Utenti/PostDipartimento', obj).subscribe((res: any) => {
      this.showMessage('Operazione avvenuta correttamente.', 'OK')
      this.dialogRef.close()
    }, (err: any) => {
      // console.log('Errore: I dati non sono stati inseriti in modo corretto');
      this.showMessage('Errore: I dati non sono stati inseriti in modo corretto.', 'OK')
    })
  }

  showMessage(message: string, action: string) {
    this.snackBar.open(message, action, { duration: 3000 })
  }
  btnAnnulla(): void {
    this.showMessage('Operazione annullata.', 'OK')
    this.dialogRef.close()
  }

}
